(() => {
  const header = document.querySelector('[data-site-header]');
  const navToggle = document.querySelector('.nav-toggle');
  document.querySelectorAll('.nav-menu-toggle').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.closest('.nav-item-group');
      const popover = group.querySelector('.nav-popover');
      const open = group.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
      popover.hidden = !open;
    });
  });
  navToggle?.addEventListener('click', () => {
    const open = header.classList.toggle('menu-open');
    navToggle.setAttribute('aria-expanded', String(open));
  });
  document.querySelectorAll('[data-product-filters]').forEach((filters) => {
    const selects = [...filters.querySelectorAll('[data-filter]')];
    const grid = filters.closest('.passenger-catalogue, section')?.querySelector('[data-product-grid]') || document.querySelector('[data-product-grid]');
    const clear = filters.querySelector('[data-clear-filters]');
    const count = filters.closest('.passenger-catalogue, section')?.querySelector('[data-results-count]') || document.querySelector('[data-results-count]');
    const apply = () => {
      const values = Object.fromEntries(selects.map((select) => [select.dataset.filter, select.value]));
      let visible = 0;
      grid?.querySelectorAll('.vehicle-card').forEach((card) => {
        const matches = Object.entries(values).every(([key, value]) => !value || card.dataset[key] === value);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (count) count.textContent = `${visible.toString().padStart(2, '0')} records shown`;
    };
    selects.forEach((select) => select.addEventListener('change', apply));
    clear?.addEventListener('click', () => {
      selects.forEach((select) => { select.value = ''; });
      apply();
    });
    apply();
  });
  document.querySelectorAll('[data-special-filters]').forEach((filters) => {
    const selects = [...filters.querySelectorAll('[data-special-filter]')];
    const section = filters.closest('.specialty-catalog-index');
    const grid = section?.querySelector('[data-special-product-grid]');
    const clear = filters.querySelector('[data-clear-special-filters]');
    const count = section?.querySelector('[data-special-results-count]');
    const apply = () => {
      const values = Object.fromEntries(selects.map((select) => [select.dataset.specialFilter, select.value]));
      let visible = 0;
      grid?.querySelectorAll('.specialty-product-card').forEach((card) => {
        const matches = Object.entries(values).every(([key, value]) => !value || card.dataset[key] === value);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (count) count.textContent = `${visible.toString().padStart(2, '0')} records shown`;
    };
    selects.forEach((select) => select.addEventListener('change', apply));
    clear?.addEventListener('click', () => {
      selects.forEach((select) => { select.value = ''; });
      apply();
    });
    document.querySelectorAll('[data-special-hero-filter]').forEach((link) => {
      link.addEventListener('click', () => {
        const application = filters.querySelector('[data-special-filter="application"]');
        if (application) application.value = link.dataset.specialHeroFilter || '';
        apply();
      });
    });
    apply();
  });
  const query = new URLSearchParams(window.location.search);
  document.querySelectorAll('[data-prefill]').forEach((field) => {
    const value = query.get(field.dataset.prefill);
    if (value) field.value = value;
  });
})();
